'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var colorManipulator = require('../../../node_modules/@material-ui/core/styles/colorManipulator.js');
var classNames = require('classnames');
var errorTheme = require('../../Styles/errorTheme.js');
var makeStyles = require('../../Styles/makeStyles.js');
var IconButton$1 = require('../../../node_modules/@material-ui/core/esm/IconButton/IconButton.js');
var ThemeProvider = require('../../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    small: {
      padding: 3,
      margin: 5
    },
    largeV2: {
      padding: 12
    },
    mediumV2: {
      padding: 8
    },
    smallV2: {
      padding: 3
    },
    deleteColor: {
      '&:hover': {
        color: theme.palette.error.main,
        backgroundColor: colorManipulator.fade(theme.palette.error.main, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    iconColor: function iconColor(_ref) {
      var _theme$palette$color;

      var color = _ref.color,
          coloredAtRest = _ref.coloredAtRest;
      var colorTheme = theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300];
      var buttonColor = ((_theme$palette$color = theme.palette[color]) === null || _theme$palette$color === void 0 ? void 0 : _theme$palette$color.main) || theme.palette.secondary.main;
      return {
        color: coloredAtRest ? colorTheme : buttonColor,
        '&:hover': {
          color: buttonColor
        }
      };
    }
  };
});

var IconButton = function IconButton(_ref2) {
  var className = _ref2.className,
      size = _ref2.size,
      color = _ref2.color,
      version = _ref2.version,
      _ref2$coloredAtRest = _ref2.coloredAtRest,
      coloredAtRest = _ref2$coloredAtRest === void 0 ? true : _ref2$coloredAtRest,
      props = objectWithoutProperties(_ref2, ["className", "size", "color", "version", "coloredAtRest"]);

  var _useStyles = useStyles({
    color: color,
    coloredAtRest: coloredAtRest
  }),
      small = _useStyles.small,
      largeV2 = _useStyles.largeV2,
      mediumV2 = _useStyles.mediumV2,
      smallV2 = _useStyles.smallV2,
      deleteColor = _useStyles.deleteColor,
      iconColor = _useStyles.iconColor;

  if (version === 'v2') {
    var iconSizeMap = {
      small: smallV2,
      medium: mediumV2,
      large: largeV2
    };
    return React__default["default"].createElement(IconButton$1["default"], _objectSpread({
      className: classNames__default["default"](className, color === 'delete' ? deleteColor : iconColor, iconSizeMap[size]),
      color: 'default'
    }, props));
  } else if (color === 'error') {
    return React__default["default"].createElement(ThemeProvider, {
      theme: errorTheme.errorTheme
    }, React__default["default"].createElement(IconButton$1["default"], _objectSpread({
      className: classNames__default["default"](className, size === 'small' && small),
      color: 'primary'
    }, props)));
  }

  return React__default["default"].createElement(IconButton$1["default"], _objectSpread({
    className: classNames__default["default"](className, size === 'small' && small, color === 'delete' && deleteColor),
    color: color === 'delete' ? 'secondary' : color
  }, props));
};

module.exports = IconButton;
